function rookeryShoppingTarget(currentHref, action, value, context) {
  const target = new URL(currentHref);
  const placementKey = 'filter.p.m.custom.placement_new';
  const styleKey = 'filter.p.m.custom.style';
  const typeKey = 'filter.p.m.custom.jewellery_type';
  const isDark = context.dark || target.pathname === '/collections/dark-moody';
  const validBase = target.searchParams.get('rookery_base');
  const base = validBase && /^\/collections\/[a-z0-9_-]+$/.test(validBase) && validBase !== '/collections/dark-moody' ? validBase : '/collections/all';
  if (context.bestsellers) {
    target.pathname = '/collections/all-jewellery-hidden-or-similar';
    target.searchParams.set('sort_by', 'best-selling');
  }
  const selected = key => target.searchParams.getAll(key).flatMap(v => v.split(','));
  const clearDark = () => {
    if (isDark) target.pathname = base;
    target.searchParams.delete('rookery_base');
  };
  if (action === 'dark') {
    if (isDark) {
      clearDark();
    } else {
      target.searchParams.set('rookery_base', target.pathname);
      target.pathname = '/collections/dark-moody';
      target.searchParams.delete(styleKey);
      if (!target.searchParams.has(typeKey)) {
        if (context.type === 'Chain' || context.type === 'Charm') {
          target.searchParams.append(typeKey, 'Chain');
          target.searchParams.append(typeKey, 'Charm');
        } else if (context.type === 'Clicker') {
          target.searchParams.append(typeKey, 'Clicker');
        }
      }
    }
  } else if (action === 'style') {
    const wasActive = selected(styleKey).includes(value);
    clearDark();
    target.searchParams.delete(styleKey);
    if (!wasActive) target.searchParams.append(styleKey, value);
  } else if (action === 'placement') {
    const values = value.split(',');
    const wasActive = values.some(item => selected(placementKey).includes(item));
    target.searchParams.delete(placementKey);
    if (!wasActive) values.forEach(item => target.searchParams.append(placementKey, item));
  } else if (action === 'clear-style') {
    clearDark();
    target.searchParams.delete(styleKey);
  } else if (action === 'clear-all') {
    clearDark();
    [...target.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.') && key !== typeKey) target.searchParams.delete(key);
    });
  } else if (action === 'clear-price') {
    target.searchParams.delete('filter.v.price.gte');
    target.searchParams.delete('filter.v.price.lte');
  } else if (action === 'remove-value' && value && value.param !== typeKey) {
    const remaining = selected(value.param).filter(item => item !== value.value);
    target.searchParams.delete(value.param);
    remaining.forEach(item => target.searchParams.append(value.param, item));
  } else if (action === 'clear-placement') {
    target.searchParams.delete(placementKey);
  }
  ['page', 'journey_type', 'journey_place'].forEach(key => target.searchParams.delete(key));
  return target;
}
if (typeof document !== 'undefined') {
  document.addEventListener('click', event => {
    const link = event.target.closest('#rookery-shopping-navigation a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const nav = link.closest('#rookery-shopping-navigation');
    if (link.dataset.rookeryCurated === 'true') {
      event.preventDefault();
      const target = new URL(link.href);
      const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewId) target.searchParams.set('preview_theme_id', previewId);
      window.location.assign(target.href);
      return;
    }
    let action, value;
    if (link.hasAttribute('data-rookery-dark')) action = 'dark';
    else if (link.dataset.rookeryClear) action = 'clear-' + link.dataset.rookeryClear;
    else if (link.dataset.rookeryRemoveParam) {
      action = 'remove-value';
      value = {param: link.dataset.rookeryRemoveParam, value: link.dataset.rookeryRemoveValue};
    }
    else if (link.dataset.rookeryFilter) {
      action = link.dataset.rookeryFilter === 'filter.p.m.custom.style' ? 'style' : 'placement';
      value = link.dataset.rookeryValue;
    } else return;
    event.preventDefault();
    const target = rookeryShoppingTarget(window.location.href, action, value, {type: nav.dataset.contextType, dark: nav.dataset.dark === 'true', bestsellers: nav.dataset.bestsellersAutomatic === 'true'});
    window.location.assign(target.href);
  });
}
